<template>
    <div class="overview-layout">
        <slot />
    </div>
</template>

<style lang="less">
/*
* Human-facing layout (cursor visible, scrollable) — unlike the kiosk screen layout.
*/
html,
body,
#__nuxt {
    margin: 0;
    padding: 0;
    background: #000;
}

.overview-layout {
    min-height: 100dvh;
    background: #000;
    color: #fff;
    cursor: auto;
    user-select: text;
    font-family: sans-serif;
}
</style>
